import { render, staticRenderFns } from "./MyHeader.vue?vue&type=template&id=12705dd1&scoped=true&"
import script from "./MyHeader.vue?vue&type=script&lang=js&"
export * from "./MyHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12705dd1",
  null
  
)

export default component.exports